<template>
  <div   :data-post-id="item.VendorSocialNetworkID" class="row py-0 align-items-center post-card-wrapper">
    <div v-if='item.TypeRole === 3 || item.TypeRole === 0' class="col-8  pr-3 pl-1">
      <router-link :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}">
        <v-avatar>
          <img
              :src="$replaceHttps(item.VendorPictureLogoUrl)"
              alt="لوگو برند">
        </v-avatar>
      </router-link>
      <span class="pr-2">{{ item.VendorName }}  <i v-if="item.IsVerified"
                                                   class="fa-solid fa-badge-check mr-1"></i></span>
    </div>
    <div v-else class="col-8  pr-7">
      <router-link :to="{path:'ProfileInSite',query:{ID:item.AppUser.Id}}">
        <v-avatar>
          <img
              v-if="item.AppUser.FileUrl !== null"
              :src="$replaceHttps(item.AppUser.FileUrl)"
              alt="تصویر کاربر">
          <i v-else class="fas fa-circle-user fa-4x"></i>
        </v-avatar>
      </router-link>
      <span class="pr-2">{{ item.AppUser.Name + ' ' + item.AppUser.Family }} <i v-if="item.IsVerified"
                                                                                class="fa-solid fa-badge-check mr-1"></i></span>
    </div>
    <!--    <div v-if="item.LocationTitle !== null" class="col-5 text-left pl-7 pb-4 pr-1 d-inline-block"
             @click="openMap(item.Latitude,item.Longitude)">
          <span class="pl-2 text-nowrap font11px pointer">{{ item.LocationTitle }}</span>
          <i class="fa-solid fa-location-dot font19px transform-icon primary-text pointer"></i>
        </div>-->
    <!--    <a :href="'https://www.google.com/maps/search/' + item.Latitude + ',' + item.Longitude"-->
    <!--       class="col-5 text-left pl-7 pb-4 pr-1 d-inline-block" target="_blank">-->
    <!--      <span class="pl-2 text-nowrap font11px pointer">{{ item.LocationTitle }}</span>-->
    <!--      <i class="fa-solid fa-location-dot font19px transform-icon primary-text pointer"></i>-->
    <!--    </a>  -->
    <span class="col-4 text-left pl-7 pb-4 pr-1 d-inline-block"
          @click="showMap(item)">
      <span class="pl-2 text-nowrap font11px pointer">{{ item.LocationTitle }}</span>
      <i class="fa-solid fa-location-dot font19px transform-icon primary-text pointer"></i>
    </span>
    <div class="col-12 px-0 px-sm-4 position-relative pt-1">
      <v-carousel
          :continuous="false"
          :cycle="cycle"
          :show-arrows="false"
          class="carousel-dots"
          dark
          delimiter-icon="fa-solid fa-circle-small white--text "
          height="680"
          hide-delimiter-background>
        <v-carousel-item
            v-for="(slide, i) in item.files"
            :key="i" style="height:680px">

          <VideoPlayer v-if="slide.type ===2" :id="id" :autoplayVideo="autoplayVideo"

                       :poster="item.FileCoverUrl" :videoSrc="slide.src"/>
          <v-img v-else :lazy-src="$replaceHttps(slide.src)" :src="$replaceHttps(slide.src)" class="col-12 bg-black"
                 contain height="680">
          </v-img>
        </v-carousel-item>
        <div class="d-flex align-items-end flex-column justify-content-end position-absolute posts-icons-wrapper">
          <div class=" py-2 px-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark"
                  @click="likeMedia(item.VendorSocialNetworkID,item)">
            <i
                :class="likeActive ?'fas fa-heart red--text' :'fas fa-heart'"
                class="font16px white--text "
            ></i>
              </span>
          </div>
          <div class="  px-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark" @click="openSendComments(item.VendorSocialNetworkID)">
            <i :class="commentsActive ?'red--text' :''"
               class="font16px white--text fa-solid fa-comments"></i>
                </span>
          </div>
          <div class=" py-2 px-1 text-center post-icons">
            <router-link v-if="isMobile"
                         :to="{path:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID,Share:true}}"
                         class="rounded-circle product-card-bookmark">
              <i class="font16px white--text fa-solid fa-paper-plane"></i>
            </router-link>
            <span v-else class="rounded-circle product-card-bookmark"
                  @click="copy('https://eyvankhaneh.app/TrendDetail?VendorSocialNetworkID='+item.VendorSocialNetworkID)">
            <i class="font16px white--text fa-solid fa-paper-plane"></i>
              </span>
          </div>
          <div v-if="isSaveStatuLoaded" class=" px-1 pb-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark"
                  @click="setBookMark(item.VendorSocialNetworkID,bookMarkActive)">
            <i :class="bookMarkActive ?'fas fa-bookmark red--text' :'fas fa-bookmark'"
               class="font16px white--text"></i>
              </span>
          </div>
          <div v-if="item.SelectedProducts !== null" class=" py-2 px-1 text-center post-icons">
            <span class="rounded-circle product-card-bookmark" @click="openRelatedProducts">
            <i :class="relatedProductsActive ? 'red--text':''"
               class="font16px white--text fa-solid fa-paperclip"></i>
              </span>

          </div>
        </div>
      </v-carousel>
    </div>
    <div class="col-7 pt-0 ">
      <v-btn class="pl-1" icon @click="openReportSheet = !openReportSheet"><i
          class="fa-regular fa-ellipsis-vertical font24px  primary-text"></i></v-btn>
      <v-btn v-if='(item.TypeRole === 3 || item.TypeRole === 0 )&& isFollow ===false' color="white" elevation="0" small
             @click="followVendor(item.VendorID)">دنبال کردن
      </v-btn>
      <v-btn v-else-if="item.TypeRole === 4 && isFollow ===false" color="white" elevation="0" small
             @click="followUser(item.AppUser.Id)">دنبال کردن
      </v-btn>
      <v-btn v-else-if="item.TypeRole === 4 && isFollow" color="primary" elevation="0" small
             @click="followUser(item.AppUser.Id)">دنبال شد
      </v-btn>
      <v-btn v-else-if="(item.TypeRole === 3 || item.TypeRole === 0) && isFollow" color="primary" elevation="0" small
             @click="followVendor(item.VendorID)">دنبال شد
      </v-btn>
    </div>
    <div class="col-5 pt-0 text-left">

      <span class="pointer" @click="getUsersLikedPost(item.VendorSocialNetworkID)">{{ item.CountLike }}</span>
      <span class="ml-2 mr-7 pointer" @click="getUsersLikedPost(item.VendorSocialNetworkID)">like</span>
      <span>{{ item.CountVisit }}</span>
      <span class="ml-2">view</span>
    </div>
    <div class="col-12 font12px" v-html="item.Description">
    </div>
    <div class="col-12  ">
      <router-link v-for="(tag,i) in item.hashtags" :key="i" :to="{path:'Trends',query:{ID:tag.HashTagID}}"
                   class="font12px grey--text"> #{{ tag.Content }}
      </router-link>
    </div>
    <div class="col-6">
      <v-btn text @click="getPostDetail(item.VendorSocialNetworkID)"> نمایش نظرات
        <span class="text-decoration-underline mx-1 font13px">{{ item.CommentCount }} نظر</span>
        <i class="fa-solid fa-arrow-left transform-icon pr-1"></i></v-btn>
    </div>
    <div class="col-6 text-left">
      <span class="font12px">{{ $convertDate(item.ModifiedDate) }}</span>
      <i class="fa-solid fa-clock-eight font16px transform-icon mr-2"></i>
    </div>
    <v-bottom-sheet v-model="openCommentSheet" scrollable>
      <v-sheet
          class="rounded-t-xl overflow-y-auto overflow-x-hidden">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8 primary-text">
            {{ item.CommentCount }} نمایش نظرات
          </div>
          <div class="col-auto pr-0 pl-0">
            <i class="fa-solid fa-arrow-down fa-xl"></i>
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="openCommentSheet = !openCommentSheet">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div v-if="comments.length <= 0" class="col-12  text-center">
          <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
          <div class="mt-2">
            هنوز نظری ثبت نشده است
          </div>

        </div>
        <div v-for="commentItem in comments" v-else :key="commentItem.VoteID" class="row mx-1">
          <div class="col-9 forth-bg rounded-lg pl-1" @click="goToCommentOwnerProfile(commentItem)">
            <v-avatar size="38">
              <img v-if="commentItem.AppUserUrl !== null" :src="$replaceHttps(commentItem.AppUserUrl)"
                   alt="تصویر کاربر">
              <i v-else class="fas fa-circle-user fa-4x"></i>
            </v-avatar>
            <span class="font-weight-bold mr-1" dir="ltr">: <i v-if="commentItem.IsVerified"
                                                               class="fa-solid fa-badge-check"></i> {{
                commentItem.AppUserName
              }} </span>
            <span class="font-weight-normal">{{ commentItem.Description }}</span>
          </div>
          <div class="col-3 text-left">
            <div> {{ $convertDate(commentItem.ModifiedDate) }}</div>
            <div>{{ commentItem.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
          </div>
          <div class="col-12">
            <div v-if="commentItem.AnswerDescription !== null" class="row">
              <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
              <div class="col-8 forth-bg rounded-lg pb-0" @click="goToCommentReplyProfile(commentItem)">
                <v-avatar size="38">
                  <img :src="$replaceHttps(commentItem.VendroPictureUrl)" alt="تصویر پاسخ دهنده">
                </v-avatar>
                <span class="font-weight-bold mr-1">{{ commentItem.VendorName }} <i v-if="item.IsVerified"
                                                                                    class="fa-solid fa-badge-check"></i>:</span>
                <span class="font-weight-normal">{{ commentItem.AnswerDescription }}</span>
              </div>
              <div class="col-3 text-left pb-0 reply-comments-action">
                <div>{{ $convertDate(commentItem.AnswerDate) }}</div>
                <div>{{ commentItem.CountLike }}
                  <v-btn icon small @click="like(commentItem.VoteID)"><i
                      class="fa-solid fa-thumbs-up fa-xl  green--text"></i>
                  </v-btn>
                </div>
                <div>{{ commentItem.CountDislike }}
                  <v-btn icon small><i class="fa-solid fa-thumbs-down fa-xl  red--text"
                                       @click="dislike(commentItem.VoteID)"></i></v-btn>
                </div>
              </div>
            </div>
          </div>

        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openLikeListsSheet" scrollable>
      <v-sheet
          class="rounded-t-xl overflow-y-auto overflow-x-hidden">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8 primary-text">
            Likes {{ item.CountLike }}
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="openLikeListsSheet = !openLikeListsSheet">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="col-12">
          <div v-for="(item,i) in userLikeList" :key="i" class="row align-items-center">
            <router-link v-if="item.TypeRole === 4" :to="{path:'ProfileInSite',query:{ID:item.AppUserId}}"
                         class="col-2 ">
              <v-avatar size="38">
                <img v-if="item.FileUrl !== null" :src="$replaceHttps(item.FileUrl)" alt="تصویر کاربر">
                <i v-else class="fas fa-circle-user fa-4x"></i>
              </v-avatar>
            </router-link>
            <router-link v-else :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}" class="col-2 ">
              <v-avatar size="38">
                <img v-if="item.FileUrl !== null" :src="$replaceHttps(item.FileUrl)" alt="تصویر فروشگاه">
                <i v-else class="fas fa-circle-user fa-4x"></i>
              </v-avatar>
            </router-link>
            <div class="col-6">
                  <span class="font-weight-bold mr-1" dir="ltr"><i v-if="item.IsVerified"
                                                                   class="fa-solid fa-badge-check mr-1"></i>
                    {{ item.Name }}  </span>
              <div class="text-truncate font12px m-0 bio-text" v-html=" item.Bio"></div>
            </div>
            <div class="col-4">
              <v-btn v-if='(item.TypeRole === 3 || item.TypeRole === 0 )&& item.isFollowed ===false' elevation="0" small
                     @click="followVendor(item.VendorID,1)">دنبال کردن
              </v-btn>
              <v-btn v-else-if="item.TypeRole === 4 && item.isFollowed ===false" elevation="0" small
                     @click="followUser(item.AppUserId,1)">دنبال کردن
              </v-btn>
              <v-btn v-else-if="item.TypeRole === 4 && item.isFollowed" color="primary" elevation="0" small
                     @click="followUser(item.AppUserId,1)">دنبال شد
              </v-btn>
              <v-btn v-else-if="(item.TypeRole === 3 || item.TypeRole === 0) && item.isFollowed" color="primary"
                     elevation="0" small
                     @click="followVendor(item.VendorID,1)">دنبال شد
              </v-btn>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openSendCommentSheet">
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8 primary-text">
            نظر خود را بنویسید
          </div>

          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="closeCommentsSheet">

           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-12 ">
            <v-textarea
                v-model="commentDescription"
                auto-grow
                background-color="secondary"
                flat
                full-width
                hide-details
                placeholder="این محتوا ..."
                rows="4"
                solo>
            </v-textarea>
          </div>
          <div class="col-3 pl-0">
            امتیاز دهید
          </div>
          <div class="col-7 pr-0">
            <v-rating
                v-model="rate"
                background-color="black"
                color="yellow"
                dense
                length="10"
                size="22"
            ></v-rating>
          </div>
          <div class="col-12 text-left pt-0">
            <v-btn class="pl-1 pb-1" icon @click="registerComment">
              <i class="fa-solid fa-square-check fa-3x black--text"></i>
            </v-btn>
          </div>

        </div>


      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openReportSheet">
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">
          <div class="col-auto font-weight-bold pr-8">
            مشکل در کدام بخش است؟
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="openReportSheet = !openReportSheet">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-12 pt-0">
            <v-radio-group v-model="radioGroup" hide-details>
              <v-radio
                  label="کلاهبرداری و نقض قانون یا وقوع جرم"
                  value="کلاهبرداری و نقض قانون یا وقوع جرم"
              ></v-radio>
              <v-radio
                  label="محتوای آگهی"
                  value="محتوای آگهی"
              ></v-radio>
              <v-radio
                  label="مشکلات صاحب آگهی"
                  value="مشکلات صاحب آگهی"
              ></v-radio>
              <div class="row">
                <div class="col-2">
                  <v-radio
                      :value="reportDescription"
                      label="سایر"
                      @change="otherReport = true"
                  ></v-radio>
                </div>
                <div class="col-8 pl-0">
                  <v-textarea
                      v-model="reportDescription"
                      :disabled="!otherReport"
                      auto-grow
                      background-color="secondary"
                      flat
                      full-width
                      hide-details
                      placeholder="این محتوا ..."
                      rows="4"
                      solo>
                  </v-textarea>
                </div>
                <div class="col-2 align-self-end ">
                  <v-btn class="pl-1 pb-1" icon @click="reportPost">
                    <i class="fa-solid fa-square-check fa-3x black--text"></i>
                  </v-btn>
                </div>
              </div>


            </v-radio-group>
          </div>

        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openRelatedProductsSheet" persistent>
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">
          <div class="col-auto pr-6 pl-0">
            <i class="fa-solid fa-paperclip fa-2x"></i>
          </div>
          <div class="col-auto font-weight-bold">
            محصولات مرتبط با این محتوا
          </div>
          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="closeProductsSheet">
           <span class="fa-stack  font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="col-12">
          <div v-if="isRelatedProductsLoaded" class="row">
            <div class="col-11 pl-0" dir="ltr">
              <carousel
                  v-if="item.relatedProducts.length >0"
                  :autoplay="false"
                  :autoplayTimeout="7000"
                  :dots="false"
                  :margin="8"
                  :nav="true"
                  :navText="navText"
                  :responsive="{0:{items:2},600:{items:3},960:{items:4}
                                                ,1050:{items:5}}"
                  :rtl="true"
                  class="owl-carousel-post-card">
                <div v-for="(product,i) in item.relatedProducts" :key="i">
                  <ProductCard :item="product"/>
                </div>
              </carousel>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="showMapDialog" fullscreen transition="dialog-bottom-transition">
      <v-card color="secondary">
        <v-card-title class="px-1">
          <v-btn icon @click="showMapDialog=false">
            <i class="fa-solid fa-circle-xmark fa-xl"></i>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="loadContent" class="px-1">
          <div class="text-left">
            <span class=" text-left   pr-1 d-inline-block">
      <span class="pl-2 text-nowrap font11px pointer">{{ item.LocationTitle }}</span>
      <i class="fa-solid fa-location-dot font19px transform-icon primary-text pointer"></i>
    </span></div>
          <PostsMap :markers="postLocation"/>
          <v-divider></v-divider>
          <div># ترند ها در حوالی این مکان</div>
          <div v-if="!hasResult" class="col-12 text-center mt-15">
            ترندی در این حوالی وجود ندارد
          </div>
          <masonry v-else
                   :cols="{default: 4, 1000: 3, 700: 2}">
            <router-link v-for="(item,i) in posts" :key="i"
                         :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"
                         class="p-1 mx-auto d-block">
              <v-img v-if="item.FileCoverUrl !== null" :lazy-src="$replaceHttps(item.FileCoverUrl)"
                     :src="$replaceHttps(item.FileCoverUrl)"
                     class=" rounded-11px"
              >
                <div class="p-2">
                  <div v-if="item.TypeStrucGallery ===2"><i
                      class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                  <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                  </div>
                </div>
              </v-img>
              <v-img v-else :lazy-src="$replaceHttps(item.FileUrl)" :src="$replaceHttps(item.FileUrl)"
                     class=" rounded-11px">
                <div class="p-2">
                  <div v-if="item.TypeStrucGallery ===2"><i
                      class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                  <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                  </div>
                </div>
              </v-img>
            </router-link>
          </masonry>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import ProductCard from "@/components/ProductCard";
import VideoPlayer from "@/components/VideoPlayer";
import PostsMap from "@/components/PostsMap";

export default {
  props: ['item', 'id'],
  name: "PostCard",
  components: {
    PostsMap,
    VideoPlayer,
    ProductCard,
    carousel,
  },
  data: () => ({
    radioGroup: null,
    posts: [],
    hasResult: true,
    reportDescription: '',
    navText: ['<i class="fa-solid fa-circle-chevron-left" aria-hidden="true"></i>'],
    showLoaderDialog: false,
    showMapDialog: false,
    showResult: false,
    text: '',
    cycle: false,
    openSendCommentSheet: false,
    openCommentSheet: false,
    openRelatedProductsSheet: false,
    openReportSheet: false,
    isRelatedProductsLoaded: true,
    relatedProductsActive: false,
    likeActive: false,
    bookMarkActive: false,
    commentsActive: false,
    relatedProducts: [],
    comments: [],
    canCopy: false,
    resultText: '',
    vendorSocialNetworkID: null,
    commentDescription: null,
    otherReport: false,
    rate: 0,
    vendorSocialID: null,
    isSaveStatuLoaded: false,
    isMobile: false,
    autoplayVideo: false,
    postLocation: [],
    loadContent: false,
    isFollow: false,
    openLikeListsSheet: false,
    userLikeList: [],
  }),
  mounted() {
    this.checkUserSaveOrLikePost()
    let userAgent = window.navigator.userAgent;
    if (userAgent.indexOf('AndroidApp') !== -1) {
      this.isMobile = true
    }
  },
  created() {
    this.canCopy = !!navigator.clipboard;
  },
  methods: {
    async copy(s) {
      await navigator.clipboard.writeText(s);
      this.resultText = 'لینک کپی شد.'
      this.showResult = true
    },
    checkUserSaveOrLikePost() {
      let saves = this.$store.getters.getUserPostsBookMark
      let likes = this.$store.getters.getUserPostsLikes
      let followings = this.$store.getters.getUserFollowings
      let type = this.item.TypeRole
      if (type === 0 || type === 3) {
        if (followings.find(x => x.VendorID === this.item.VendorID) !== undefined) {
          this.isFollow = true
        }
      } else {
        if (followings.find(x => x.FollowedAppUserId === this.item.AppUser.Id) !== undefined) {
          this.isFollow = true
        }
      }

      let id = this.item.VendorSocialNetworkID
      if (saves !== null && saves.length > 0) {
        if (saves.find(x => x.VendorSocialNetworkID === id) !== undefined) {
          this.bookMarkActive = true
        }
      }
      if (likes !== null && likes.length > 0) {
        if (likes.find(x => x.VendorSocialNetworkID === id) !== undefined) {
          this.likeActive = true
        }
      }
      this.isSaveStatuLoaded = true
    },
    openRelatedProducts() {
      this.relatedProductsActive = !this.relatedProductsActive
      this.openRelatedProductsSheet = !this.openRelatedProductsSheet
    },
    closeProductsSheet() {
      this.relatedProductsActive = !this.relatedProductsActive
      this.openRelatedProductsSheet = !this.openRelatedProductsSheet
    },
    openSendComments(id) {
      this.vendorSocialNetworkID = id
      this.commentsActive = !this.commentsActive
      this.openSendCommentSheet = !this.openSendCommentSheet
    },
    closeCommentsSheet() {
      this.commentsActive = !this.commentsActive
      this.openSendCommentSheet = !this.openSendCommentSheet
    },
    getPostDetail(id) {
      this.vendorSocialID = id
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/SpecialSocialNetwork", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            let json = JSON.parse(result)

            this.comments = json.VoteViewModel
            this.openCommentSheet = true

          })
          .catch(error => console.log('error', error));
    },
    like(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVoteLike", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getPostDetail(this.vendorSocialID)
          })
          .catch(error => console.log('error', error));
    },
    dislike(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVoteDislike", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getPostDetail(this.vendorSocialID)
          })
          .catch(error => console.log('error', error));
    },
    registerComment() {
      this.openSendCommentSheet = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", this.vendorSocialNetworkID);
      urlencoded.append("Rate", this.rate);
      urlencoded.append("Description", this.commentDescription);
      urlencoded.append("TypeVote", "2");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVote", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.commentsActive = !this.commentsActive
          })
          .catch(error => console.log('error', error));
    },
    likeMedia(id, item) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetSocialNetworkLike", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.likeActive = !this.likeActive
              if (this.likeActive) {
                item.CountLike++
              } else {
                item.CountLike--
              }
              this.$store.commit('addOrRemovePostLikeToList', id)

            }

            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    setBookMark(id, isBookMark) {
      if (isBookMark) {
        this.removeBookmark(id)
      } else {
        this.addBookmark(id)
      }
    },
    addBookmark(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("RelationID", id);
      urlencoded.append("TypeBookMark", "3");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false

            if (resStatus === 200) {
              this.bookMarkActive = true

              this.$store.commit('addOrRemovePostBookMarkItemToList', id)
            }
            this.resultText = result
            this.showResult = true


          })
          .catch(error => console.log('error', error));
    },
    removeBookmark(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("BookMarkID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/RemoveBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false

            if (resStatus === 200) {
              this.bookMarkActive = false

              this.$store.commit('addOrRemovePostBookMarkItemToList', id)
            }
            this.resultText = result
            this.showResult = true


          })
          .catch(error => console.log('error', error));
    },
    openMap(lat, lng) {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = "https://www.google.com/maps/search/" + lat + ',' + lng + "?hl=en"
      a.target = '_blank'
      // a.download = <your_fileName>;
      a.click();
      document.body.removeChild(a);
    },
    reportPost() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", this.item.VendorSocialNetworkID);
      urlencoded.append("Description", this.radioGroup);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/SetVendorSocialNetworkReportFailure", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.openReportSheet = false
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    goToCommentOwnerProfile(item) {
      if (item.TypeRoleCommentOwner === "Vendor") {
        this.$router.push({path: 'StoreProfile', query: {VendorID: item.VendorCommentOwnerId}})
      } else {
        this.$router.push({path: 'ProfileInSite', query: {ID: item.AppUserId}})
      }
    },
    goToCommentReplyProfile(item) {
      if (item.TypeRole === "Vendor") {
        this.$router.push({path: 'StoreProfile', query: {VendorID: item.VendorID}})
      } else {
        this.$router.push({path: 'ProfileInSite', query: {ID: item.VendorID}})
      }
    },
    showMap(item) {
      this.postLocation = [{
        position: {lat: item.Latitude, lng: item.Longitude},
        icon: item.FileCoverUrl,
      }]

      this.getNearPosts(item.Latitude, item.Longitude)


    },
    followVendor(id, type) {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.isFollow = !this.isFollow
              let payload = {id: id, type: 2}
              this.$store.commit('addOrRemoveFollowingItemToList', payload)
              if (type === 1) {
                this.getUsersLikedPost(this.item.VendorSocialNetworkID)
              }
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    followUser(id, type) {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("FollowedAppUserId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.isFollow = !this.isFollow
              let payload = {id: id, type: 1}
              this.$store.commit('addOrRemoveFollowingItemToList', payload)
              if (type === 1) {
                this.getUsersLikedPost(this.item.VendorSocialNetworkID)
              }
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    getNearPosts(lat, lng) {

      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();


      urlencoded.append("longitude", lng);
      urlencoded.append("latitude", lat);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/NearPosts", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length > 0) {
              this.posts = json.sort((a, b) => b.ModifiedDate.localeCompare(a.ModifiedDate))
              this.hasResult = true
            } else {
              this.hasResult = false
            }
            this.showMapDialog = true
            this.loadContent = true
          })
          .catch(error => console.log('error', error));

    },
    getUsersLikedPost(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("vendorSocialNetworkId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/UsersLikedPost", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            let json = JSON.parse(result)
            let followings = this.$store.getters.getUserFollowings
            for (let i = 0; i < json.length; i++) {
              if (json[i].TypeRole === 4) {
                let find = followings.find(x => x.FollowedAppUserId === json[i].AppUserId)
                json[i].isFollowed = find !== undefined;
              } else {
                let find = followings.find(x => x.VendorID === json[i].VendorID)
                json[i].isFollowed = find !== undefined;
              }
            }


            this.userLikeList = json.reverse()
            this.openLikeListsSheet = true

          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

